import type { RelatedProductItem } from '@libs/common-types';

const CACHE_PREFIX = 'recommended_products';

const toSortedUniqueIds = (productIds: string | string[]): string[] => {
    const ids = Array.isArray(productIds) ? productIds : [productIds];
    return [...new Set(ids.map(id => id.trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b));
};

export const getRecommendedProductsCacheKey = (productIds: string | string[], customerId?: string): string =>
    `${CACHE_PREFIX}:${toSortedUniqueIds(productIds).join(',')}:${customerId ?? '0'}`;

export const readCachedRecommendedProducts = (cacheKey: string): RelatedProductItem[] | null => {
    try {
        const raw = globalThis.sessionStorage.getItem(cacheKey);
        if (!raw) return null;

        const parsed: unknown = JSON.parse(raw);
        return Array.isArray(parsed) ? (parsed as RelatedProductItem[]) : null;
    } catch {
        return null;
    }
};

export const writeCachedRecommendedProducts = (cacheKey: string, items: RelatedProductItem[]): void => {
    try {
        globalThis.sessionStorage.setItem(cacheKey, JSON.stringify(items));
    } catch {
        // Non-fatal: the carousel should still render fetched data.
    }
};
